import ticketingUser from './ticketing-user'

export default [
  ...ticketingUser,
]
